export * from './toolbar-item.component';



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./src/lib/tool/toolbar-item/index.ts